import request from '@/api/request'

/**
 * 获取分页
 */
export const getVeteranPageList = (data) => {
  return request({
    url: '/radioweb/adm/veteran/page',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 获取分页
 */
export const veteranManage = (data) => {
  let url = 'radioweb/adm/veteran/add'
  if (data.id) {
    url = '/radioweb/adm/veteran/update'
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 修改状态
 */
export const updateStatus = (data) => {
  return request({
    url: '/radioweb/adm/veteran/updateStatus',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 修改置顶状态
 */
export const topInformation = (data) => {
  return request({
    url: '/radioweb/adm/veteran/updateTopFlag',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 删除
 */
export const veteranDel = (data) => {
  return request({
    url: '/radioweb/adm/veteran/del',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 获取资讯附件
 */
export const getAttachFiles = (data) => {
  return request({
    url: `/radioweb/adm/veteran/getVeteranFileList`,
    method: 'post',
    type: 'json',
    data
  })
}
